import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { ExportService } from '../../services/export.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from '../download-excel/download-excel.component';
import { CommonCsvComponent } from '../common-csv/common-csv.component';
import { CommonBulkPrintComponent } from '../common-bulk-print/common-bulk-print.component';
import { ExportHelperService } from '../../services/export-helper.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent {
  selectedRows: any[] = [];
  allColumns: any[] = [];

  exportFormat: any = 'Excel';
  fileName: string = '';
  columnsToExport: string[] = [];
  includeLineItems: boolean = false;
  dropdownOptions:any;
  customHeaders: { label: string; startCol: number; endCol: number }[] = [];
  @ViewChild('excelExporter') excelExporter!: DownloadExcelComponent;
  @ViewChild('csvExporter') csvExporter!: CommonCsvComponent;
  @ViewChild('pdfExporter') pdfExporter!: CommonBulkPrintComponent;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private exportHelperService: ExportHelperService
  ) {}

  ngOnInit(): void {
    
    this.selectedRows = this.config.data?.selectedRows || [];
    this.allColumns = this.config.data?.allColumns || [];
    this.fileName = this.config.data?.fileName || [];
    this.includeLineItems = this.config.data?.includeLineItems
    // this.fileName = this.config.data?.fileName || [];
    // this.columnsToExport = this.allColumns.map(col => col.key);
    if (this.fileName === 'Ageing Report') {
      this.customHeaders = [
        { label: 'Days', startCol: 1, endCol: 1 },
        { label: '0-2', startCol: 2, endCol: 4 },
        { label: '3-5', startCol: 5, endCol: 7 },
        { label: '6-10', startCol: 8, endCol: 10 },
        { label: '11+', startCol: 11, endCol: 13 },
        { label: 'Total', startCol: 14, endCol: this.allColumns.length }
      ];
    }
    if(this.includeLineItems){
      const excludedKeys = ['approvalUser', 'Invoice Due Date'];
        const filteredColumns = this.allColumns.filter(col => 
          !excludedKeys.includes(col.key)
        );

        this.dropdownOptions = filteredColumns.map(col => ({
          label: col.header,
          value: col.id ?? col.key 
        }));
        this.columnsToExport = filteredColumns.map(col => col.id ?? col.key);

    }
    else{
      this.dropdownOptions = this.allColumns.map(col => ({
        label: col.header,
        value: col.id ?? col.key 
      }));
      this.columnsToExport = this.allColumns.map(col => col.id ?? col.key);
    }
    console.log('Selected Rows:', this.selectedRows);
    console.log('includeLineItems:', this.includeLineItems);
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allColumns'] && this.allColumns?.length > 0) {
      this.dropdownOptions = this.allColumns.map(col => ({
        label: col.header,
        value: col.id ?? col.key
      }));
      this.columnsToExport = this.allColumns.map(col => col.id ?? col.key);
    }
  }

  onExport() {
    if (this.selectedRows?.length > 0) {
      this.triggerExport(this.selectedRows);
    } else {
      // If no selection, fetch all paginated data
      const chunkSize = 500;
      const params = this.config.data?.exportParams || {};
      const exportApi = this.config.data?.exportApi;
  
      if (exportApi && params) {
        this.exportHelperService.exportPaginatedChunks<any>(
          exportApi,
          params,
          chunkSize,
          (allData) => {
            this.triggerExport(allData);
          }
        );
      } else {
        alert('Export API or params not provided!');
      }
    }
  }
  
  triggerExport(data: any[]) {
    const selectedColumns = this.allColumns.filter(col =>
      this.columnsToExport.includes(col.id ?? col.key)
    );
    if (this.exportFormat === 'Excel') {
      this.excelExporter.exportData = data;
      this.excelExporter.columns = selectedColumns;
      this.excelExporter.includeLineItems = this.includeLineItems;
      if(this.customHeaders.length>0){
        this.excelExporter.customHeaders = this.customHeaders;
      }
      this.excelExporter.exportToExcel();
    } else if (this.exportFormat === 'CSV') {
      this.csvExporter.exportData = data;
      this.csvExporter.columns = selectedColumns;
      this.csvExporter.includeLineItems = this.includeLineItems;
      if(this.customHeaders.length>0){
        this.csvExporter.customHeaders = this.customHeaders;
      }
      this.csvExporter.exportToCsv();
    } else if (this.exportFormat === 'PDF') {
      this.pdfExporter.exportData = data;
      this.pdfExporter.columns = selectedColumns;
      if(this.customHeaders.length>0){
        this.pdfExporter.customHeaders = this.customHeaders;
      }
      this.pdfExporter.downloadPDF();
    }
  }
  
  // PRINT
  onPrint() {
    if (this.selectedRows?.length > 0) {
      this.triggerPrint(this.selectedRows);
    } else {
      const chunkSize = 250;
      const params = this.config.data?.exportParams || {};
      const exportApi = this.config.data?.exportApi;
  
      if (exportApi && params) {
        this.exportHelperService.exportPaginatedChunks<any>(
          exportApi,
          params,
          chunkSize,
          (allData) => {
            this.triggerPrint(allData);
          }
        );
      } else {
        alert('Export API or params not provided!');
      }
    }
  }

  triggerPrint(data: any[]) {
    const selectedColumns = this.allColumns.filter(col =>
      this.columnsToExport.includes(col.id ?? col.key)
    );
    this.pdfExporter.data = data;
    this.pdfExporter.columns = selectedColumns;
    this.pdfExporter.printRecords();
  }

  selectAllColumns(): void {
    this.columnsToExport = this.allColumns.map(col => col.id ?? col.key);
  }
  
  clearAllColumns(): void {
    this.columnsToExport = [];
  }
}
